'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}();function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}} // Copyright 2015-2017 Parity Technologies (UK) Ltd.
// This file is part of Parity.

// Parity is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.

// Parity is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.

// You should have received a copy of the GNU General Public License
// along with Parity.  If not, see <http://www.gnu.org/licenses/>.
var _require =
require('../../format/input'),inAddress = _require.inAddress,inAddresses = _require.inAddresses,inBlockNumber = _require.inBlockNumber,inData = _require.inData,inDeriveHash = _require.inDeriveHash,inDeriveIndex = _require.inDeriveIndex,inHex = _require.inHex,inNumber16 = _require.inNumber16,inOptions = _require.inOptions;var _require2 =
require('../../format/output'),outAccountInfo = _require2.outAccountInfo,outAddress = _require2.outAddress,outAddresses = _require2.outAddresses,outBlock = _require2.outBlock,outChainStatus = _require2.outChainStatus,outHistogram = _require2.outHistogram,outHwAccountInfo = _require2.outHwAccountInfo,outNodeKind = _require2.outNodeKind,outNumber = _require2.outNumber,outPeers = _require2.outPeers,outRecentDapps = _require2.outRecentDapps,outTransaction = _require2.outTransaction,outVaultMeta = _require2.outVaultMeta;var

Parity = function () {
  function Parity(provider) {_classCallCheck(this, Parity);
    this._provider = provider;
  }_createClass(Parity, [{ key: 'acceptNonReservedPeers', value: function acceptNonReservedPeers()

    {
      return this._provider.
      send('parity_acceptNonReservedPeers');
    } }, { key: 'accountsInfo', value: function accountsInfo()

    {
      return this._provider.
      send('parity_accountsInfo').
      then(outAccountInfo);
    } }, { key: 'allAccountsInfo', value: function allAccountsInfo()

    {
      return this._provider.
      send('parity_allAccountsInfo').
      then(outAccountInfo);
    } }, { key: 'addReservedPeer', value: function addReservedPeer(

    enode) {
      return this._provider.
      send('parity_addReservedPeer', enode);
    } }, { key: 'call', value: function call(

    requests) {var blockNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'latest';
      return this._provider.
      send('parity_call', requests.map(function (options) {return inOptions(options);}), inBlockNumber(blockNumber));
    } }, { key: 'chain', value: function chain()

    {
      return this._provider.
      send('parity_chain');
    } }, { key: 'chainId', value: function chainId()

    {
      return this._provider.
      send('parity_chainId');
    } }, { key: 'chainStatus', value: function chainStatus()

    {
      return this._provider.
      send('parity_chainStatus').
      then(outChainStatus);
    } }, { key: 'changePassword', value: function changePassword(

    account, password, newPassword) {
      return this._provider.
      send('parity_changePassword', inAddress(account), password, newPassword);
    } }, { key: 'changeVault', value: function changeVault(

    account, vaultName) {
      return this._provider.
      send('parity_changeVault', inAddress(account), vaultName);
    } }, { key: 'changeVaultPassword', value: function changeVaultPassword(

    vaultName, password) {
      return this._provider.
      send('parity_changeVaultPassword', vaultName, password);
    } }, { key: 'checkRequest', value: function checkRequest(

    requestId) {
      return this._provider.
      send('parity_checkRequest', inNumber16(requestId));
    } }, { key: 'cidV0', value: function cidV0(

    data) {
      return this._provider.
      send('parity_cidV0', inData(data));
    } }, { key: 'closeVault', value: function closeVault(

    vaultName) {
      return this._provider.
      send('parity_closeVault', vaultName);
    } }, { key: 'composeTransaction', value: function composeTransaction(

    options) {
      return this._provider.
      send('parity_composeTransaction', inOptions(options));
    } }, { key: 'consensusCapability', value: function consensusCapability()

    {
      return this._provider.
      send('parity_consensusCapability');
    } }, { key: 'dappsList', value: function dappsList()

    {
      return this._provider.
      send('parity_dappsList');
    } }, { key: 'dappsRefresh', value: function dappsRefresh()

    {
      return this._provider.
      send('parity_dappsRefresh');
    } }, { key: 'dappsUrl', value: function dappsUrl()

    {
      return this._provider.
      send('parity_dappsUrl');
    } }, { key: 'decryptMessage', value: function decryptMessage(

    address, data) {
      return this._provider.
      send('parity_decryptMessage', inAddress(address), inHex(data));
    } }, { key: 'defaultAccount', value: function defaultAccount()

    {
      return this._provider.
      send('parity_defaultAccount').
      then(outAddress);
    } }, { key: 'defaultExtraData', value: function defaultExtraData()

    {
      return this._provider.
      send('parity_defaultExtraData');
    } }, { key: 'devLogs', value: function devLogs()

    {
      return this._provider.
      send('parity_devLogs');
    } }, { key: 'devLogsLevels', value: function devLogsLevels()

    {
      return this._provider.
      send('parity_devLogsLevels');
    } }, { key: 'deriveAddressHash', value: function deriveAddressHash(

    address, password, hash, shouldSave) {
      return this._provider.
      send('parity_deriveAddressHash', inAddress(address), password, inDeriveHash(hash), !!shouldSave).
      then(outAddress);
    } }, { key: 'deriveAddressIndex', value: function deriveAddressIndex(

    address, password, index, shouldSave) {
      return this._provider.
      send('parity_deriveAddressIndex', inAddress(address), password, inDeriveIndex(index), !!shouldSave).
      then(outAddress);
    } }, { key: 'dropNonReservedPeers', value: function dropNonReservedPeers()

    {
      return this._provider.
      send('parity_dropNonReservedPeers');
    } }, { key: 'enode', value: function enode()

    {
      return this._provider.
      send('parity_enode');
    } }, { key: 'encryptMessage', value: function encryptMessage(

    pubkey, data) {
      return this._provider.
      send('parity_encryptMessage', inHex(pubkey), inHex(data));
    } }, { key: 'executeUpgrade', value: function executeUpgrade()

    {
      return this._provider.
      send('parity_executeUpgrade');
    } }, { key: 'exportAccount', value: function exportAccount(

    address, password) {
      return this._provider.
      send('parity_exportAccount', inAddress(address), password);
    } }, { key: 'extraData', value: function extraData()

    {
      return this._provider.
      send('parity_extraData');
    } }, { key: 'futureTransactions', value: function futureTransactions()

    {
      return this._provider.
      send('parity_futureTransactions');
    } }, { key: 'gasCeilTarget', value: function gasCeilTarget()

    {
      return this._provider.
      send('parity_gasCeilTarget').
      then(outNumber);
    } }, { key: 'gasFloorTarget', value: function gasFloorTarget()

    {
      return this._provider.
      send('parity_gasFloorTarget').
      then(outNumber);
    } }, { key: 'gasPriceHistogram', value: function gasPriceHistogram()

    {
      return this._provider.
      send('parity_gasPriceHistogram').
      then(outHistogram);
    } }, { key: 'generateSecretPhrase', value: function generateSecretPhrase()

    {
      return this._provider.
      send('parity_generateSecretPhrase');
    } }, { key: 'getBlockHeaderByNumber', value: function getBlockHeaderByNumber()

    {var blockNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'latest';
      return this._provider.
      send('parity_getBlockHeaderByNumber', inBlockNumber(blockNumber)).
      then(outBlock);
    } }, { key: 'getDappAddresses', value: function getDappAddresses(

    dappId) {
      return this._provider.
      send('parity_getDappAddresses', dappId).
      then(outAddresses);
    } }, { key: 'getDappDefaultAddress', value: function getDappDefaultAddress(

    dappId) {
      return this._provider.
      send('parity_getDappDefaultAddress', dappId).
      then(outAddress);
    } }, { key: 'getNewDappsAddresses', value: function getNewDappsAddresses()

    {
      return this._provider.
      send('parity_getNewDappsAddresses').
      then(function (addresses) {return addresses ? addresses.map(outAddress) : null;});
    } }, { key: 'getNewDappsDefaultAddress', value: function getNewDappsDefaultAddress()

    {
      return this._provider.
      send('parity_getNewDappsDefaultAddress').
      then(outAddress);
    } }, { key: 'getVaultMeta', value: function getVaultMeta(

    vaultName) {
      return this._provider.
      send('parity_getVaultMeta', vaultName).
      then(outVaultMeta);
    } }, { key: 'hardwareAccountsInfo', value: function hardwareAccountsInfo()

    {
      return this._provider.
      send('parity_hardwareAccountsInfo').
      then(outHwAccountInfo);
    } }, { key: 'lockedHardwareAccountsInfo', value: function lockedHardwareAccountsInfo()

    {
      return this._provider.
      send('parity_lockedHardwareAccountsInfo');
    } }, { key: 'hardwarePinMatrixAck', value: function hardwarePinMatrixAck(

    path, pin) {
      return this._provider.
      send('parity_hardwarePinMatrixAck', path, pin);
    } }, { key: 'hashContent', value: function hashContent(

    url) {
      return this._provider.
      send('parity_hashContent', url);
    } }, { key: 'importGethAccounts', value: function importGethAccounts(

    accounts) {
      return this._provider.
      send('parity_importGethAccounts', inAddresses(accounts)).
      then(outAddresses);
    } }, { key: 'killAccount', value: function killAccount(

    account, password) {
      return this._provider.
      send('parity_killAccount', inAddress(account), password);
    } }, { key: 'listAccounts', value: function listAccounts(

    count) {var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;var blockNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'latest';
      return this._provider.
      send('parity_listAccounts', count, inAddress(offset), inBlockNumber(blockNumber)).
      then(function (accounts) {return (accounts || []).map(outAddress);});
    } }, { key: 'listOpenedVaults', value: function listOpenedVaults()

    {
      return this._provider.
      send('parity_listOpenedVaults');
    } }, { key: 'listVaults', value: function listVaults()

    {
      return this._provider.
      send('parity_listVaults');
    } }, { key: 'listRecentDapps', value: function listRecentDapps()

    {
      return this._provider.
      send('parity_listRecentDapps').
      then(outRecentDapps);
    } }, { key: 'listStorageKeys', value: function listStorageKeys(

    address, count) {var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;var blockNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'latest';
      return this._provider.
      send('parity_listStorageKeys', inAddress(address), count, inHex(hash), inBlockNumber(blockNumber));
    } }, { key: 'removeAddress', value: function removeAddress(

    address) {
      return this._provider.
      send('parity_removeAddress', inAddress(address));
    } }, { key: 'listGethAccounts', value: function listGethAccounts()

    {
      return this._provider.
      send('parity_listGethAccounts').
      then(outAddresses);
    } }, { key: 'localTransactions', value: function localTransactions()

    {
      return this._provider.
      send('parity_localTransactions').
      then(function (transactions) {
        Object.values(transactions).
        filter(function (tx) {return tx.transaction;}).
        map(function (tx) {
          tx.transaction = outTransaction(tx.transaction);
        });
        return transactions;
      });
    } }, { key: 'minGasPrice', value: function minGasPrice()

    {
      return this._provider.
      send('parity_minGasPrice').
      then(outNumber);
    } }, { key: 'mode', value: function mode()

    {
      return this._provider.
      send('parity_mode');
    }

    // DEPRECATED - use chain instead.
  }, { key: 'netChain', value: function netChain() {
      return this._provider.
      send('parity_chain');
    } }, { key: 'nodeHealth', value: function nodeHealth()

    {
      return this._provider.
      send('parity_nodeHealth');
    } }, { key: 'nodeKind', value: function nodeKind()

    {
      return this._provider.
      send('parity_nodeKind').
      then(outNodeKind);
    } }, { key: 'netPeers', value: function netPeers()

    {
      return this._provider.
      send('parity_netPeers').
      then(outPeers);
    } }, { key: 'netMaxPeers', value: function netMaxPeers()

    {
      return this._provider.
      send('parity_netMaxPeers').
      then(outNumber);
    } }, { key: 'netPort', value: function netPort()

    {
      return this._provider.
      send('parity_netPort').
      then(outNumber);
    } }, { key: 'newAccountFromPhrase', value: function newAccountFromPhrase(

    phrase, password) {
      return this._provider.
      send('parity_newAccountFromPhrase', phrase, password).
      then(outAddress);
    } }, { key: 'newAccountFromSecret', value: function newAccountFromSecret(

    secret, password) {
      return this._provider.
      send('parity_newAccountFromSecret', inHex(secret), password).
      then(outAddress);
    } }, { key: 'newAccountFromWallet', value: function newAccountFromWallet(

    json, password) {
      return this._provider.
      send('parity_newAccountFromWallet', json, password).
      then(outAddress);
    } }, { key: 'newVault', value: function newVault(

    vaultName, password) {
      return this._provider.
      send('parity_newVault', vaultName, password);
    } }, { key: 'nextNonce', value: function nextNonce(

    account) {
      return this._provider.
      send('parity_nextNonce', inAddress(account)).
      then(outNumber);
    } }, { key: 'nodeName', value: function nodeName()

    {
      return this._provider.
      send('parity_nodeName');
    } }, { key: 'openVault', value: function openVault(

    vaultName, password) {
      return this._provider.
      send('parity_openVault', vaultName, password);
    } }, { key: 'pendingTransactions', value: function pendingTransactions()

    {
      return this._provider.
      send('parity_pendingTransactions').
      then(function (data) {return data.map(outTransaction);});
    } }, { key: 'pendingTransactionsStats', value: function pendingTransactionsStats()

    {
      return this._provider.
      send('parity_pendingTransactionsStats');
    } }, { key: 'phraseToAddress', value: function phraseToAddress(

    phrase) {
      return this._provider.
      send('parity_phraseToAddress', phrase).
      then(outAddress);
    } }, { key: 'postSign', value: function postSign(

    address, hash) {
      return this._provider.
      send('parity_postSign', inAddress(address), inHex(hash));
    } }, { key: 'postTransaction', value: function postTransaction()

    {var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this._provider.
      send('parity_postTransaction', inOptions(options));
    } }, { key: 'registryAddress', value: function registryAddress()

    {
      return this._provider.
      send('parity_registryAddress').
      then(outAddress);
    } }, { key: 'releasesInfo', value: function releasesInfo()

    {
      return this._provider.
      send('parity_releasesInfo');
    } }, { key: 'removeReservedPeer', value: function removeReservedPeer(

    enode) {
      return this._provider.
      send('parity_removeReservedPeer', enode);
    } }, { key: 'removeTransaction', value: function removeTransaction(

    hash) {
      return this._provider.
      send('parity_removeTransaction', inHex(hash)).
      then(outTransaction);
    } }, { key: 'rpcSettings', value: function rpcSettings()

    {
      return this._provider.
      send('parity_rpcSettings');
    } }, { key: 'setAccountName', value: function setAccountName(

    address, name) {
      return this._provider.
      send('parity_setAccountName', inAddress(address), name);
    } }, { key: 'setAccountMeta', value: function setAccountMeta(

    address, meta) {
      return this._provider.
      send('parity_setAccountMeta', inAddress(address), JSON.stringify(meta));
    } }, { key: 'setAuthor', value: function setAuthor(

    address) {
      return this._provider.
      send('parity_setAuthor', inAddress(address));
    } }, { key: 'setDappAddresses', value: function setDappAddresses(

    dappId, addresses) {
      return this._provider.
      send('parity_setDappAddresses', dappId, inAddresses(addresses));
    } }, { key: 'setDappDefaultAddress', value: function setDappDefaultAddress(

    dappId, address) {
      return this._provider.
      send('parity_setDappDefaultAddress', dappId, address ? inAddress(address) : null);
    } }, { key: 'setEngineSigner', value: function setEngineSigner(

    address, password) {
      return this._provider.
      send('parity_setEngineSigner', inAddress(address), password);
    } }, { key: 'setExtraData', value: function setExtraData(

    data) {
      return this._provider.
      send('parity_setExtraData', inData(data));
    } }, { key: 'setGasCeilTarget', value: function setGasCeilTarget(

    quantity) {
      return this._provider.
      send('parity_setGasCeilTarget', inNumber16(quantity));
    } }, { key: 'setGasFloorTarget', value: function setGasFloorTarget(

    quantity) {
      return this._provider.
      send('parity_setGasFloorTarget', inNumber16(quantity));
    } }, { key: 'setMaxTransactionGas', value: function setMaxTransactionGas(

    quantity) {
      return this._provider.
      send('parity_setMaxTransactionGas', inNumber16(quantity));
    } }, { key: 'setMinGasPrice', value: function setMinGasPrice(

    quantity) {
      return this._provider.
      send('parity_setMinGasPrice', inNumber16(quantity));
    } }, { key: 'setMode', value: function setMode(

    mode) {
      return this._provider.
      send('parity_setMode', mode);
    } }, { key: 'setChain', value: function setChain(

    specName) {
      return this._provider.
      send('parity_setChain', specName);
    } }, { key: 'setNewDappsAddresses', value: function setNewDappsAddresses(

    addresses) {
      return this._provider.
      send('parity_setNewDappsAddresses', addresses ? inAddresses(addresses) : null);
    } }, { key: 'setNewDappsDefaultAddress', value: function setNewDappsDefaultAddress(

    address) {
      return this._provider.
      send('parity_setNewDappsDefaultAddress', inAddress(address));
    } }, { key: 'setTransactionsLimit', value: function setTransactionsLimit(

    quantity) {
      return this._provider.
      send('parity_setTransactionsLimit', inNumber16(quantity));
    } }, { key: 'setVaultMeta', value: function setVaultMeta(

    vaultName, meta) {
      return this._provider.
      send('parity_setVaultMeta', vaultName, JSON.stringify(meta));
    } }, { key: 'signMessage', value: function signMessage(

    address, password, messageHash) {
      return this._provider.
      send('parity_signMessage', inAddress(address), password, inHex(messageHash));
    } }, { key: 'testPassword', value: function testPassword(

    account, password) {
      return this._provider.
      send('parity_testPassword', inAddress(account), password);
    } }, { key: 'transactionsLimit', value: function transactionsLimit()

    {
      return this._provider.
      send('parity_transactionsLimit').
      then(outNumber);
    } }, { key: 'unsignedTransactionsCount', value: function unsignedTransactionsCount()

    {
      return this._provider.
      send('parity_unsignedTransactionsCount').
      then(outNumber);
    } }, { key: 'upgradeReady', value: function upgradeReady()

    {
      return this._provider.
      send('parity_upgradeReady');
    } }, { key: 'versionInfo', value: function versionInfo()

    {
      return this._provider.
      send('parity_versionInfo');
    } }, { key: 'wsUrl', value: function wsUrl()

    {
      return this._provider.
      send('parity_wsUrl');
    } }]);return Parity;}();


module.exports = Parity;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@parity/api/lib/rpc/parity/parity.js
// module id = 461
// module chunks = 0